/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获剧院城市列表-不带首字母
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<dictionary.PlaceCityDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/dictionary/place/city/list`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
